export enum ChatType {
	MentorStudent = 'mentor_student',
	TeacherStudent = 'teacher_student',
	MentorParent = 'mentor_parent',
	TeacherParent = 'teacher_parent',
}
